import axios from "services/axios";
import {useMutation} from "react-query";

export function useValidateOtp(options = {}) {
	return useMutation(values => axios.post("/auth/validate_otp", values).then(res => res.data));
}
